import type { OAuthContext } from './types';

const CONTEXT_SCRIPT_ID = '__OAUTH_CONTEXT__';

export function readOAuthContext(): OAuthContext {
  const el = document.getElementById(CONTEXT_SCRIPT_ID);
  if (!el) {
    return {
      error: 'invalid_request',
      error_description: `Missing #${CONTEXT_SCRIPT_ID} script tag`,
    };
  }

  const raw = el.textContent || '';
  if (!raw.trim()) {
    return {
      error: 'invalid_request',
      error_description: `Empty #${CONTEXT_SCRIPT_ID} payload`,
    };
  }

  try {
    return JSON.parse(raw) as OAuthContext;
  } catch (e: any) {
    return {
      error: 'invalid_request',
      error_description: `Invalid JSON in #${CONTEXT_SCRIPT_ID}: ${e?.message || String(e)}`,
    };
  }
}
